import { Box, Typography } from "@mui/material";
import { StyledFooter } from "./Footer.styled";
import {
  EnvelopeIcon,
  FacebookLogoIcon,
  InstagramLogoIcon,
} from "@phosphor-icons/react";
import { Phone } from "@phosphor-icons/react/dist/ssr";
import { useNavigate } from "react-router-dom";
import { useNavbar } from "../../Hooks/useNavbar";

export const Footer = () => {
  const navigate = useNavigate();
  const { Navlinks } = useNavbar();

  return (
    <StyledFooter>
      <Box className="footer">
        <Box className="text">
          <Typography variant="h3">Wie is Bijnens A.rt?</Typography>
          <Typography variant="body1">
            Bijnens Anja is een kunstenares die vormen, lijnen, structuren en
            abstracte figuren gebruikt en dit zowel op doek als op sculpturen.
            Voor elke vorm gebruikt ze tot 4 lagen verf en dit in felle kleuren.
            Waardoor er in elk schilderij of sculptuur heel wat werk kruipt. Bij
            de afwerking gebruikt ze een stiptechniek "Dotpainting".
          </Typography>
        </Box>
        <Box className="divider" />
        <Box className="info">
          <Typography variant="h3">Gegevens</Typography>
          <Box className="infoitem phone">
            <Phone size={32} />
            <Typography variant="h4">+32 494/99.39.71</Typography>
          </Box>
          <Box className="infoitem email">
            <EnvelopeIcon size={32} />
            <Typography variant="h4">info@bijnensart.be</Typography>
          </Box>
          <Box className="infoitem instagram">
            <InstagramLogoIcon size={32} />
            <Typography variant="h4">@bijnens_a</Typography>
          </Box>
          <Box className="infoitem facebook">
            <FacebookLogoIcon size={32} />
            <Typography variant="h4">@bijnens.a.rt</Typography>
          </Box>
        </Box>
        <Box className="divider" />
        <Box className="links">
          <Typography variant="h3">Links</Typography>
          {Navlinks.map((navlink) => (
            <Typography variant="h4" onClick={() => navigate(navlink.path)}>
              {navlink.title}
            </Typography>
          ))}
        </Box>
      </Box>
      <Box className="copyright"><Typography variant="h5">BijnensArt since 2019 - Copyright Ⓒ All rights reserved - Website design provided by Wannes Schillebeeckx</Typography></Box>
    </StyledFooter>
  );
};
